export default __webpack_public_path__ + "static/media/netflix-clone-demo.c893533f.mp4";